import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ModalController, NavController, Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor() {}

  public accessToken: string;
}
